import { cn } from "@/lib/utils"

type NodeSurfaceProps = {
	children: React.ReactNode
	className?: string
	selected?: boolean
	tone?: "default" | "selected"
	withShadow?: boolean
}

export function NodeSurface({
	children,
	className,
	selected = false,
	tone = "default",
	withShadow = true,
}: NodeSurfaceProps) {
	const usesSelectedTone = tone === "selected" || selected

	return (
		<div
			className={cn(
				"relative rounded-[20px]",
				usesSelectedTone
					? "bg-[var(--node-selection)] text-white"
					: "bg-[var(--node-bg)] text-[var(--node-text)]",
				className,
			)}
		>
			<div className="relative z-10 flex h-full w-full min-h-0 flex-col">
				{children}
			</div>
			{withShadow ? (
				<div
					aria-hidden="true"
					className="pointer-events-none absolute inset-0 z-20 rounded-[inherit] shadow-[var(--node-shell-shadow)]"
				/>
			) : null}
		</div>
	)
}
